export enum CardListCellTypes {
    text = 'text',
    link = 'link',
    image = 'image',
    icon = 'icon',
    statusIcon = 'statusIcon'
}
